/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_TitleInputs */



/**
* | output |
* | --- |
* | "Notification Settings" |
*
* @param {Options_Notifications_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_title = /** @type {((inputs?: Options_Notifications_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de notifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benachrichtigungseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di notifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки уведомлений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de notificaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("通知设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("通知設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिसूचना सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de notificação")
	return /** @type {LocalizedString} */ ("Notification Settings")
});